<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-12">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{"gestion-permisos-expediente" | translate :{ expediente: expediente } }}
      </h2>
    </div>
  </div>
</div>
<div class="wrapper__form container my-5 border__form">
  <app-form
    [title]="title"
    [fields]="fieldsBusquedaPorCedula"
    [sumbitButtonText]="submitButton"
    (submitAction)="onSubmitBuscarUsuario($event)"></app-form>
</div>
<div class="wrapper__form container my-5">
  <app-form
    [fields]="fieldsInfoUsuarioBusqueda"
    [sumbitButtonText]="permisosButton"
    (changeAction)="onChangeInfoUsuario($event)"
    [withSubmitButton]="false"></app-form>
  <app-form
    *ngIf="habilitarBotonPermisos"
    [fields]="fieldsGestionPermisos"
    [sumbitButtonText]="permisosButton"
    (submitAction)="asignarPermiso($event)"></app-form>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="contenedor-tabla w-100">
    <app-table
    [estiloEncabezado]="'height: auto !important;'"
    id="usuarios"
    [datos]="usuariosAsignados"
    [paginaActual]="paginaActual"
    [columnas]="columns"
    [acciones]="actions"
    [paginacion]="true"
    [tamano]="tamanoPagina"
    [totalPaginas]="totalPaginas"
    (eventoAccion)="permisos($event, true)"
    [tamanos]="[1, 5, 10, 20]"></app-table>
</div>
</div>
